import { FEATURES } from './features.constants'
import * as environment from '@environment/environment.constant'

export const FEATURE_FLAGS = {
  [FEATURES.CONTENT]: environment.FEATURE_FLAG_FEED_CONTENT,
} as const
